import { PaddedContainer, SPACING } from "@disco/disco_core";
import React, { createContext } from "react";
import EssentialWidgetCard from "./EssentialWidgetCard";
import useDimensions from "../../hooks/useDimensions";
import useMode from "../../hooks/useMode";

const EssentialWidgetBackgroundWrapper = ({ children }) => {
	const { inDesktopOnly } = useDimensions();
	const { isInline } = useMode();
	return (
		<PaddedContainer
			className="essential-widget-background-wrapper"
			vPadding={
				!isInline && (inDesktopOnly ? SPACING.MEGA : SPACING.JUMBO)
			}
		>
			{children}
		</PaddedContainer>
	);
};

export const EssentialWidgetOfferContext = createContext(); // Defining on parent file to prevent circular dep
const EssentialWidget = () => {
	const [counter, setCounter] = React.useState(0);

	const triggerRemount = React.useCallback(
		() => setCounter((prev) => prev + 1),
		[]
	);

	return (
		<EssentialWidgetBackgroundWrapper>
			<EssentialWidgetCard
				key={counter}
				triggerRemount={triggerRemount}
			/>
		</EssentialWidgetBackgroundWrapper>
	);
};
export default EssentialWidget;
